__turbopack_context__.v({
  "caption": "_3NmXaa_caption",
  "carouselContainer": "_3NmXaa_carouselContainer",
  "carouselControls": "_3NmXaa_carouselControls",
  "embla": "_3NmXaa_embla",
  "embla__container": "_3NmXaa_embla__container",
  "embla__next": "_3NmXaa_embla__next",
  "embla__prev": "_3NmXaa_embla__prev",
  "embla__slide": "_3NmXaa_embla__slide",
  "imgContainer": "_3NmXaa_imgContainer",
  "text": "_3NmXaa_text",
  "title": "_3NmXaa_title",
  "whitePaperArticle": "_3NmXaa_whitePaperArticle",
  "whitepaperSectionContainer": "_3NmXaa_whitepaperSectionContainer",
});
